import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "number1",
  "use": "number1-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"number1\"><defs><style>#number1 .cls-1{fill:#00c4fb;}#number1 .cls-2{fill:#fff;}</style></defs><polygon class=\"cls-1\" points=\"46.543 26.963 45.564 26.963 50.784 2 88.963 2 88.8 2.979 91.574 6.569 66.285 126 40.343 126 37.406 122.41 36.426 122.41 56.006 30.389 49.316 30.389 46.543 26.963\" /><polygon class=\"cls-2\" points=\"39.364 119.963 61.39 119.963 86.027 4.447 52.742 4.447 48.501 24.515 59.758 24.515 39.364 119.963\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol